import { marketplaceMeta, HUB_STATUS_LABELS, STATUS_LABELS } from "../lib/api";

const HUB_COLORS = {
  imported: { bg: "#F1F5F9", text: "#0F172A", dot: "#64748B" },
  awaiting_review: { bg: "#FFF7ED", text: "#9A3412", dot: "#F97316" },
  approved: { bg: "#ECFDF5", text: "#065F46", dot: "#10B981" },
  rejected: { bg: "#FEF2F2", text: "#991B1B", dot: "#EF4444" },
  sent_to_erp: { bg: "#EFF6FF", text: "#1E3A8A", dot: "#3B82F6" },
  nf_authorized: { bg: "#EEF2FF", text: "#3730A3", dot: "#6366F1" },
  nf_sent: { bg: "#F0F9FF", text: "#075985", dot: "#0EA5E9" },
  label_ready: { bg: "#F0FDF4", text: "#166534", dot: "#22C55E" },
  in_separation: { bg: "#FEFCE8", text: "#854D0E", dot: "#EAB308" },
  separated: { bg: "#ECFEFF", text: "#155E75", dot: "#06B6D4" },
  packed: { bg: "#FAF5FF", text: "#6B21A8", dot: "#A855F7" },
  dispatched: { bg: "#F0F9FF", text: "#0C4A6E", dot: "#0284C7" },
  blocked: { bg: "#FEF2F2", text: "#7F1D1D", dot: "#DC2626" },
};

export function HubStatusBadge({ status }) {
  const c = HUB_COLORS[status] || { bg: "#F1F5F9", text: "#0F172A", dot: "#64748B" };
  return (
    <span
      data-testid={`hub-status-${status}`}
      className="inline-flex items-center gap-1.5 px-2 py-1 text-[10px] font-bold uppercase tracking-wider"
      style={{ background: c.bg, color: c.text }}
    >
      <span className="status-dot" style={{ background: c.dot }} />
      {HUB_STATUS_LABELS[status] || status}
    </span>
  );
}

const MKT_STATUS_COLORS = {
  paid: "#10B981",
  approved: "#10B981",
  ready_to_ship: "#10B981",
  awaiting_post: "#10B981",
  pending_payment: "#F59E0B",
  awaiting_payment: "#F59E0B",
  cancelled: "#DC2626",
  refunded: "#DC2626",
  in_dispute: "#DC2626",
  returned: "#DC2626",
  cancel_requested: "#DC2626",
};

export function MarketStatusBadge({ status }) {
  const dot = MKT_STATUS_COLORS[status] || "#64748B";
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-slate-700">
      <span className="status-dot" style={{ background: dot }} />
      {STATUS_LABELS[status] || status}
    </span>
  );
}

export function MarketplaceTag({ id }) {
  const m = marketplaceMeta(id);
  return (
    <span
      className="inline-flex items-center px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider"
      style={{ background: m.color, color: m.text }}
    >
      {m.label}
    </span>
  );
}
